import forge from "node-forge";
import { KEYS } from "../../constants.js";

export function encryption(payload, aesKeyHex, ivHex) {
    let aesKey, iv;

    if (!aesKeyHex) {
        aesKey = forge.random.getBytesSync(32);
        aesKeyHex = forge.util.bytesToHex(aesKey);
    } else {
        aesKey = forge.util.hexToBytes(aesKeyHex);
    }

    if (!ivHex) {
        iv = forge.random.getBytesSync(16);
        ivHex = forge.util.bytesToHex(iv);
    } else {
        iv = forge.util.hexToBytes(ivHex);
    }

    const plaintext = JSON.stringify(payload);
    const plaintextBuffer = forge.util.createBuffer(plaintext, "utf8");

    const aesKeyBuffer = forge.util.createBuffer(aesKey, "raw");
    const ivBuffer = forge.util.createBuffer(iv, "raw");

    const cipher = forge.cipher.createCipher("AES-CBC", aesKeyBuffer);

    cipher.start({ iv: ivBuffer });
    cipher.update(plaintextBuffer);
    cipher.finish();

    const encryptedPayload = cipher.output.toHex();

    // Calculate MAC
    const hmac = forge.hmac.create();
    hmac.start("sha256", aesKey);
    hmac.update(encryptedPayload);
    const mac = hmac.digest().toHex();

    return {
        [ KEYS.AES_KEY_HEX ]: aesKeyHex,
        [ KEYS.IV_HEX ]: ivHex,
        [ KEYS.ENCRYPTED_PAYLOAD ]: encryptedPayload,
        [ KEYS.MAC ]: mac
    }

}

export function decryption(encryptedPayloadHex, aesKeyHex, ivHex) {

    const aesKey = forge.util.hexToBytes(aesKeyHex);
    const iv = forge.util.hexToBytes(ivHex);
    const encryptedPayload = forge.util.hexToBytes(encryptedPayloadHex);

    const decipher = forge.cipher.createDecipher("AES-CBC", aesKey);
    decipher.start({ iv: iv });
    decipher.update(forge.util.createBuffer(encryptedPayload));
    const result = decipher.finish();

    if (result) {
        const decryptedPayload = decipher.output.toString();
        // Calculate MAC
        const hmac = forge.hmac.create();
        hmac.start("sha256", aesKey);
        hmac.update(encryptedPayloadHex);
        const mac = hmac.digest().toHex();
        return {
            decryptedPayload: JSON.parse(decryptedPayload),
            decryptedMac: mac
        };
    } else {
        // Decryption fail
        return null
    }

}

export const setEncryptedStorage = (key, value, aesKeyHex, ivHex) => {
  const encrypted = encryption(value, aesKeyHex, ivHex);
  localStorage.setItem(key, JSON.stringify(encrypted));
};

export const getDecryptedStorage = (key) => {
  const encryptedData = localStorage.getItem(key);
  if (!encryptedData) return null;

  try {
    const parsed = JSON.parse(encryptedData);
    const { decryptedPayload } = decryption(
      parsed[KEYS.ENCRYPTED_PAYLOAD],
      parsed[KEYS.AES_KEY_HEX],
      parsed[KEYS.IV_HEX]
    );
    return decryptedPayload;
  } catch (err) {
    console.error("Decryption failed", err);
    return null;
  }
};
